module.exports = __webpack_public_path__ + "static/img/test02.440e91d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/test02.png
// module id = 5RaD
// module chunks = 1